import { render } from "./CounselorTable.vue?vue&type=template&id=8be00834&scoped=true"
import script from "./CounselorTable.vue?vue&type=script&lang=js"
export * from "./CounselorTable.vue?vue&type=script&lang=js"

import "./CounselorTable.vue?vue&type=style&index=0&id=8be00834&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8be00834"]])

export default __exports__